import { showGuestSuccess, showSuccess } from 'state/modules/dialog';
import { change } from 'redux-form/lib';
import guestTypes from './types';
import { showGuestError } from '../dialog/actions';

export default ({ dispatch }) => next => action => {
  const { type, result } = action;
  // Handle UPDATE case BEFORE calling next(action)
  if (type === guestTypes.UPDATE) {
    // Clear passport file immediately when update request is dispatched
    if (action.passportUpload) {
      dispatch(change('guestForm', 'passportImage', null));
    }
    return next(action);
  }
  const response = next(action);
  switch (type) {
    case guestTypes.UPDATE_SUCCESS: {
      if (result.validation?.errors?.length > 0) {
        dispatch(showGuestError({ title: 'dialog.message.edit.guest.fail', message: result.validation.errors }));
      }
      else {
        dispatch(showGuestSuccess({ messageId: 'dialog.message.detailsChange.success', validation: result.validation }));
      }
      break;
    }
    case guestTypes.UPDATE_FAIL: {
      if (result?.validation?.errors?.length > 0) {
        dispatch(showGuestError({ message: result.validation.errors, title: 'dialog.message.edit.guest.fail' }));
      }
      break;
    }
    case guestTypes.LOAD_OWN_SUCCESS: {
      if (action.isPolling === true && result?.passportErrors?.length < 1 && result?.passportScanVerified === true) {
        dispatch(showSuccess('dialog.message.uploadPassport.verified'));
      }
      else if (action.isPolling === true && result?.passportErrors?.length > 0 && result?.passportScanVerified === false) {
        dispatch(showGuestError({ message: result.passportErrors, title: 'dialog.message.uploadPassport.verifiedFailed' }));
      }
      break;
    }
    default:
      break;
  }

  return response;
};
